import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Dumbbell, Plane, Compass, HeartPulse, Landmark, Users, ArrowRight } from "lucide-react";
import api from "../lib/api";
import Reveal from "../components/Reveal";
import { PillButton, Overline } from "../components/primitives";

const pillars = [
  { icon: Dumbbell, title: "Fitness", body: "Hybrid Fitness, strength, endurance, Pilates, mobility and recovery — coached daily." },
  { icon: Plane, title: "Travel", body: "Everything handled: flights, transfers, hotel, and local transportation." },
  { icon: Compass, title: "Adventure", body: "Volcano hikes, surf sessions, and outdoor challenges in stunning settings." },
  { icon: HeartPulse, title: "Wellness", body: "Recovery, nutrition, and movement designed to leave you better than you arrived." },
  { icon: Landmark, title: "Culture", body: "Immersive local experiences, food, and the Ruta de las Flores." },
  { icon: Users, title: "Community", body: "A like-minded group of adults who train hard and travel far, together." },
];

export default function About() {
  const [content, setContent] = useState({});
  useEffect(() => { api.get("/content/about").then((r) => setContent(r.data)).catch(() => {}); }, []);

  return (
    <div className="pt-16 md:pt-20">
      <section className="relative py-28 md:py-36 bg-[#0D1110] text-white overflow-hidden">
        <div className="noise-overlay" />
        <img src="https://images.unsplash.com/photo-1778694276890-b136a8c466f9?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600" alt="" className="absolute inset-0 w-full h-full object-cover opacity-30" />
        <div className="relative z-10 max-w-4xl mx-auto px-6 md:px-10">
          <Reveal>
            <Overline>About Us</Overline>
            <h1 className="mt-4 font-display font-extrabold tracking-tighter text-4xl md:text-6xl leading-[0.98]">{content.title || "Fitness. Travel. Adventure. Wellness. Culture. Community."}</h1>
          </Reveal>
        </div>
      </section>

      <section className="py-20 md:py-28">
        <div className="max-w-3xl mx-auto px-6 md:px-10">
          <Reveal><p className="text-xl text-foreground/75 leading-relaxed">{content.body}</p></Reveal>
        </div>
      </section>

      <section className="pb-24">
        <div className="max-w-7xl mx-auto px-6 md:px-10">
          <div className="grid md:grid-cols-3 gap-4">
            {pillars.map((p, i) => (
              <Reveal key={i} delay={(i % 3) * 0.08}>
                <div className="h-full rounded-2xl border border-black/10 bg-white p-8 hover:shadow-lg hover:-translate-y-1 transition-[transform,box-shadow] duration-200">
                  <p.icon className="w-8 h-8 text-primary" strokeWidth={1.75} />
                  <div className="mt-4 font-display font-bold text-xl">{p.title}</div>
                  <p className="mt-2 text-sm text-foreground/70 leading-relaxed">{p.body}</p>
                </div>
              </Reveal>
            ))}
          </div>
          <div className="mt-12 flex flex-wrap gap-4">
            <Link to="/founders"><PillButton variant="dark">Meet the Founders <ArrowRight className="w-4 h-4" /></PillButton></Link>
            <Link to="/book"><PillButton>Book Your Retreat</PillButton></Link>
          </div>
        </div>
      </section>
    </div>
  );
}
